import styled from 'styled-components';
import { AA_LINK_ON_LIGHT } from '~/modules/Helper/contrast.helper';

export const ToolsSection = styled.section`
  margin-top: 8px;
  width: 100%;
`;

export const ToolsHeading = styled.h2`
  margin: 0 0 16px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: ${({ theme }) => theme?.a11y?.textPrimaryOnLight || '#262626'};
`;

export const ToolsGrid = styled.ul`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin: 0;
  padding: 0;
  list-style: none;
  width: 100%;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

export const ToolCard = styled.li`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  min-height: 100%;
  padding: 20px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background: ${({ theme }) => theme?.a11y?.surfaceOnLight || '#ffffff'};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
`;

export const ToolLogoWrap = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  color: ${({ theme }) => theme?.corTema || AA_LINK_ON_LIGHT};

  svg {
    display: block;
    height: 44px;
    width: auto;
    max-width: 100%;
  }
`;

export const ToolName = styled.h3`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.4;
  color: ${({ theme }) => theme?.a11y?.textPrimaryOnLight || '#262626'};
`;

export const ToolLinkRow = styled.dl`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 4px 12px;
  margin: 0;
`;

export const ToolLinkLabel = styled.dt`
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: ${({ theme }) => theme?.a11y?.textOnLight || '#8c8c8c'};
`;

export const ToolLinkValue = styled.dd`
  margin: 0;
  min-width: 0;
`;

export const ToolLink = styled.a`
  display: inline-block;
  max-width: 100%;
  overflow-wrap: anywhere;
  font-size: 13px;
  line-height: 1.5;
  color: ${({ theme }) => theme?.colors?.primary || '#1890ff'};
  text-decoration: none;

  &:hover,
  &:focus {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme?.colors?.primary || '#1890ff'};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const ToolSummary = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.55;
  color: ${({ theme }) => theme?.a11y?.textOnLight || '#595959'};
`;
